<template>
  <v-dialog v-model="show" max-width="560" persistent>
    <v-card class="ma-0 pa-0">
      <v-card-title
        class="pt-4 px-6 text-h6 ma-0 pa-0 blue-grey--text text--darken-3 font-weight-600"
      >
        {{ $t('people.actions.reset') }}
      </v-card-title>
      <v-card-subtitle
        class="px-6 text-body-1 blue-grey--text text--darken-1 ma-0 pa-0 my-6 font-weight-500"
      >
        <p
          class="ma-0 pa-0"
          v-html="
            $sanitize($t('people.reset_password_subtitle', { email }), {
              allowedTags: ['br'],
            })
          "
        />
      </v-card-subtitle>
      <v-card-text class="ma-0 pa-0 px-6">
        <p
          class="text-subtitle-2 font-weight-700 blue-grey--text text--darken-3"
        >
          {{ $t('common.temporary_password') }}
        </p>
        <v-form v-model="form.isValid" ref="password">
          <AddPassword
            :password="form.password"
            :isLoading="isLoading"
            :confirmPassword="form.confirmPassword"
            @change="handlePasswordChange"
          />
        </v-form>
      </v-card-text>

      <v-divider class="my-6 ma-0 pa-0" />
      <v-card-actions class="justify-end ma-0 pa-0 pb-4 px-6">
        <Button
          plain
          color="blueGrey"
          text="Cancel"
          @click="handleCancel"
          :disabled="isLoading"
        />
        <Button text="Reset" @click="handleReset" :disabled="isLoading" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'
import AddPassword from '@/components/AddPassword.vue'

export default {
  name: 'DiscardChangesConfirmation',

  components: {
    Button,
    AddPassword,
  },

  props: {
    show: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      form: {
        password: '',
        confirmPassword: '',
      },
    }
  },

  methods: {
    handleCancel() {
      this.form = { password: '', confirmPassword: '' }
      this.$refs.password.resetValidation()
      this.$emit('cancel')
    },

    handleReset() {
      this.$refs.password.validate()
      if (this.form.isValid) return this.$emit('reset', this.form.password)
    },

    handlePasswordChange(password) {
      this.form = { ...this.form, ...password }
    },
  },
}
</script>
